import { DISPLAY_NOTIFICATION } from "./types";

export const displayNotification = notice => dispatch =>
  dispatch({ type: DISPLAY_NOTIFICATION, notice });
